import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dashboards-twin-table-table-component"
  }, [_c(VTextField, {
    staticClass: "mb-2",
    attrs: {
      "label": _vm.$t('Dashboards.components.twinTable.search.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "clearable": "",
      "dense": "",
      "hide-details": "",
      "data-cy": "twin-table-search"
    },
    model: {
      value: _vm.searchTerm,
      callback: function ($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  }), _c(VDataTable, {
    attrs: {
      "loading": _vm.isLoading,
      "headers": _vm.headers,
      "items": _vm.items,
      "options": _vm.tableOptionsState,
      "server-items-length": _vm.serverItemsLength,
      "footer-props": {
        itemsPerPageText: _vm.$t('Common.rowsPerPage'),
        itemsPerPageOptions: _vm.itemsPerPageOptions
      },
      "fixed-header": _vm.headers.some(header => header.width),
      "no-data-text": _vm.$t('Dashboards.components.twinTable.search.noData'),
      "multi-sort": false
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptionsState = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n          " + _vm._s(items.pageStart) + " - " + _vm._s(items.pageStop) + " " + _vm._s(_vm.$t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n        ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptionsState.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptionsState.itemsPerPage,
            "title-txt": _vm.$t('Common.goToPage')
          },
          on: {
            "page-change": _vm.setTablePage
          }
        })], 1)], 1)];
      }
    }, {
      key: "item",
      fn: function ({
        item,
        headers
      }) {
        return [_c('tr', {
          style: {
            cursor: _vm.rowHasClickHandler(item).isTrue ? 'pointer' : undefined
          },
          attrs: {
            "data-cy": `row-twin-${item.__twin_id__}`
          },
          on: {
            "click": function ($event) {
              return _vm.onRowClick(item);
            }
          }
        }, _vm._l(headers, function (header) {
          return _c('td', {
            key: header.text,
            style: {
              width: header.width,
              maxWidth: header.width,
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            },
            attrs: {
              "data-cy": header.dataCy
            }
          }, [header.component !== 'string' ? _c(header.component, {
            tag: "component",
            attrs: {
              "data": _vm.getByKey(item, header.value)
            }
          }) : _c('span', {
            attrs: {
              "title": _vm.getByKey(item, header.value)
            }
          }, [_vm._v("\n            " + _vm._s(_vm.getByKey(item, header.value)) + "\n          ")])], 1);
        }), 0)];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };